export { default } from './editorconfig.js';
